import { useTranslation } from '@shared/localization';
import { useEffect } from 'react';

import { disableUIBlocker, PageLayout } from '@/components/common';
import { AlertLoading } from '@/components/common/alerts';

interface PaymentProcessingProps {
  readonly title: string;
  readonly orderId?: string;
}

export function PaymentProcessing({ title, orderId }: PaymentProcessingProps) {
  const { t } = useTranslation();

  useEffect(() => {
    disableUIBlocker();
  }, []);

  return (
    <PageLayout
      headerDescription={
        orderId
          ? t('Order: {{orderNumber}}', { orderNumber: orderId })
          : undefined
      }
    >
      <AlertLoading title={title} />
    </PageLayout>
  );
}
